import { Component } from '@angular/core';

/**
 * Generated class for the RcsKdQuotationEditComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'rcs-kd-quotation-edit',
  templateUrl: 'rcs-kd-quotation-edit.html'
})
export class RcsKdQuotationEditComponent {

  text: string;

  constructor() {
    console.log('Hello RcsKdQuotationEditComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/rcs-kd-quotation-edit/rcs-kd-quotation-edit.ts